import React from 'react';

const disableLinkStyles = {
  pointerEvents: 'none',
  opacity: 0.3,
};
const enableLinkStyles = {
  pointerEvents: 'auto',
};

function SideBarTitlePanel({
  disableEdit,
  flagForAddTag,
  flagForEditTag,
  cancelTagging,
  disableDone,
  doneTagging,
  closeButton,
  editTagging,
  children,
}) {
  return (
    <div className="sidebar-box">
      <div className="sidebar-header">
        {flagForAddTag || flagForEditTag ? (
          <div>
            <a
              href="javascript:void(0);"
              className="page-options float-left"
              onClick={cancelTagging}
            >
              Cancel
            </a>
            <a
              href="javascript:void(0);"
              disabled={disableDone}
              style={disableDone ? disableLinkStyles : enableLinkStyles}
              className="page-options float-right"
              onClick={doneTagging}
            >
              Done
            </a>
          </div>
        ) : (
          <div>
            <a
              href="javascript:void(0);"
              className="page-options float-left"
              onClick={closeButton}
            >
              Close
            </a>
            <a
              href="javascript:void(0);"
              disabled={disableEdit}
              style={disableEdit ? disableLinkStyles : enableLinkStyles}
              className="page-options float-right"
              onClick={editTagging}
            >
              Edit
            </a>
          </div>
        )}
      </div>
      {children}
    </div>
  );
}

export { SideBarTitlePanel };
